import mkad from '@/js/data/coords/mkad-out.ts';
import obl from '@/js/data/coords/mosobl.ts';

declare global {
  const turf: typeof import('@turf/turf');
}

export function getBooleanPointInPolygon(polygon: number[][][], point: number[]): boolean {
  const pt = turf.point(point);
  const poly = turf.polygon(polygon);
  return turf.booleanPointInPolygon(pt, poly);
}

export function convertCoordinates(coordinates: number[][][]) {
  return coordinates.map(polygon =>
    polygon.map(point => [point[1], point[0]]),
  );
}

export function isPointInMkadPolygon(point: number[]) {
  return getBooleanPointInPolygon(convertCoordinates([mkad.coordinates[0]]), point);
}

export function isPointInMosoblPolygon(point: number[]) {
  const coordinates = convertCoordinates([
    obl.coordinates[0],
    mkad.coordinates[0],
  ]);
  return getBooleanPointInPolygon(coordinates, point);
}

export function findClosestPointOnMkadPolygon(point: number[]) {
  const line = turf.lineStrings(convertCoordinates([mkad.coordinates[0]]));
  const result = turf.nearestPointOnLine(line, point, { units: 'metres' });
  return result.geometry.coordinates;
}
